import React from 'react';
import { useNavigate } from 'react-router-dom';
import './PageTemplate.css';

const PameBrosta = () => {
  const navigate = useNavigate();

  return (
    <div className="page-container">
      <div className="page-content">
        <img src="/assets/pame-logo.jpg" alt="PAME Brosta" className="page-logo" />
        <h1>PAME BROSTA by <span className="theo-red">Theo</span></h1>
        
        <div className="page-text">
          <p>
            PAME BROSTA is a global cultural initiative launched by TheaMou by Theo during 
            Athens Fashion Week on November 14, 2025, with the Greek phrase "Πάμε Μπροστά" 
            meaning "Let's Go Forward!".
          </p>
          
          <p>
            It serves as a call to Hellenes, the Greek diaspora, and Philhellenes worldwide 
            to reignite the flame of unity, excellence, love, and wisdom, reconnecting with 
            the True Light of Greece.
          </p>
          
          <p>
            The movement is guided by the Five Divine Human Characteristics: Body & Beauty, 
            Mind & Wisdom, Heart & Soul, Courage, and Purpose & Vision.
          </p>

          <p>
            It is championed by Olympic Angels by Theo and launched by Theometrics Global as 
            part of a broader effort to revive the original Olympic spirit and promote 
            sustainable prosperity through culture, education, and entrepreneurship.
          </p>
        </div>
      </div>
    </div>
  );
};

export default PameBrosta;
